import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useSearchZone = () => {
  const [loading, setLoading] = useState(true);
  const [searchZoneList, setSearchZoneList] = useState([]);

  const { enqueueSnackbar } = useSnackbar();

  const getSearchZoneList = (input = '') => {
    setLoading(true);

    axiosClient
      .get(`InventoryGeo/Zone/Search?SearchTerm=${input}`)
      .then(res => {
        if (res.status === 200) {
          setSearchZoneList(res.data.value);
        } else {
          enqueueSnackbar(res.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };

  return [getSearchZoneList, loading, searchZoneList];
};

export default useSearchZone;
